
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import {
  AssetDeviceConfigRequest,
  AssetDeviceConfigResponseBody,
} from '../entities/asset-device-config-v2/models';
import { DeviceConfigPostResponse } from '../entities/asset-device-config-v1/device-config-post-response';
import { AssetDeviceConfigurationRequest } from './types';
import { axiosInstance } from "../axios-instance";

class AssetDeviceConfiguration {
  private authClient: OAuth2Client | null;

  private baseUrlV2: string;

  constructor(authClient: OAuth2Client | null, baseUrlV2: string) {
    this.authClient = authClient;
    this.baseUrlV2 = baseUrlV2;
  }

  queueAssetDeviceConfiguration(
    input: AssetDeviceConfigRequest,
  ): Promise<AxiosResponse<AssetDeviceConfigResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<AssetDeviceConfigResponseBody>(`${this.baseUrlV2}/queueConfigs`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  getConfigurationForAsset(
    queryParameters:any
    ): Promise<any>{
      const accessToken = localStorage.getItem('accessToken');
      return axiosInstance.get<any>(`${this.baseUrlV2}/configStatuses`, {
        params: queryParameters,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      }).catch((error) => {
        throw new Error(error);
      });
    }

  postConfigurationForAsset(
    input: AssetDeviceConfigurationRequest,
  ): Promise<AxiosResponse<DeviceConfigPostResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    const { make, serialNumber, body, ...queryParameters } = input;
    return axiosInstance.post<DeviceConfigPostResponse>(`${this.baseUrlV2}/queueCommands`, body, {
      params: queryParameters,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default AssetDeviceConfiguration;
